var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';
import { useAutoSaveField } from '../../../Components/AutosaveForm/AutosaveField';
import { FullScreenModal } from '../../../Components/FullScreenModal';
import { DecisionSupportStatus, MedicationType, PrescriptionMonitoringStatus } from '../../../Contracts/MedicationModels';
import { DecisionSupport } from '../../../FinaliseMedication/DecisionSupport/DecisionSupport';
import { useDecisionSupportStatusUpdatedSignalR } from '../../../SignalR/DecisionSupportSignalR';
import { DecisionAlertBar } from './DecisionAlertBar';
import { DecisionAlertFloating } from './DecisionAlertFloating';
export function DecisionSupportBanner(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var medicationTypeField = useAutoSaveField({ field: 'medicationType' });
    var _p = __read(useState({
        decisionSupportDetail: {
            status: props.decisionSupportDetail.decisionSupportStatus,
            noted: props.decisionSupportDetail.decisionSupportNoted,
            numberOfTotalAlerts: props.decisionSupportDetail.numberOfTotalAlerts,
            prescriptionMonitoringDetail: {
                status: (_c = (_b = (_a = props.patientMedication.decisionSupportDetail) === null || _a === void 0 ? void 0 : _a.prescriptionMonitoringDetail) === null || _b === void 0 ? void 0 : _b.status) !== null && _c !== void 0 ? _c : PrescriptionMonitoringStatus.NotChecked,
                responseDescription: (_f = (_e = (_d = props.patientMedication.decisionSupportDetail) === null || _d === void 0 ? void 0 : _d.prescriptionMonitoringDetail) === null || _e === void 0 ? void 0 : _e.responseDescription) !== null && _f !== void 0 ? _f : '',
                responseUrl: (_j = (_h = (_g = props.patientMedication.decisionSupportDetail) === null || _g === void 0 ? void 0 : _g.prescriptionMonitoringDetail) === null || _h === void 0 ? void 0 : _h.responseUrl) !== null && _j !== void 0 ? _j : ''
            }
        }
    }), 2), decisionSupport = _p[0], setDecisionSupport = _p[1];
    var _q = __read(useState(false), 2), showWizard = _q[0], setShowWizard = _q[1];
    useDecisionSupportStatusUpdatedSignalR({
        patient: props.patient,
        onSignalResponse: function (decisionSupportStatusUpdated) {
            setDecisionSupport(decisionSupportStatusUpdated);
        }
    });
    var showDecisionSupportWizard = function () {
        setShowWizard(true);
    };
    var hideDecisionSupportWizard = function () {
        setShowWizard(false);
    };
    var showFloatingDecisionAlert = useMediaQuery('(min-width:1450px)');
    var showDecisionAlert = false;
    if (((_k = medicationTypeField.fieldValue) === null || _k === void 0 ? void 0 : _k.value) !== MedicationType.MedicationHistory) {
        if (showFloatingDecisionAlert) {
            // We want to see Pass decision support for the floating banner
            if (decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Passed ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Information ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Warning ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Alert ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Error) {
                showDecisionAlert = true;
            }
        }
        else {
            if (decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Information ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Warning ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Alert ||
                decisionSupport.decisionSupportDetail.status === DecisionSupportStatus.Error) {
                showDecisionAlert = true;
            }
        }
    }
    return (React.createElement(React.Fragment, null,
        showWizard && (React.createElement(FullScreenModal, { title: '', info: '', onClose: hideDecisionSupportWizard },
            React.createElement(DecisionSupport, { patient: props.patient, patientMedication: __assign(__assign({}, props.patientMedication), { 
                    // Make sure that decision support passed down is the latest we've gotten from signalR
                    decisionSupportDetail: {
                        numberOfTotalAlerts: decisionSupport.decisionSupportDetail.numberOfTotalAlerts,
                        decisionSupportStatus: decisionSupport.decisionSupportDetail.status,
                        decisionSupportNoted: decisionSupport.decisionSupportDetail.noted,
                        prescriptionMonitoringDetail: {
                            status: (_l = decisionSupport.decisionSupportDetail) === null || _l === void 0 ? void 0 : _l.prescriptionMonitoringDetail.status,
                            responseDescription: (_m = decisionSupport.decisionSupportDetail) === null || _m === void 0 ? void 0 : _m.prescriptionMonitoringDetail.responseDescription,
                            responseUrl: (_o = decisionSupport.decisionSupportDetail) === null || _o === void 0 ? void 0 : _o.prescriptionMonitoringDetail.responseUrl
                        }
                    } }), onNavigateToMedication: props.onNavigateToMedication, onContinue: function () {
                    hideDecisionSupportWizard();
                } }))),
        showDecisionAlert ? (showFloatingDecisionAlert ? (React.createElement(DecisionAlertFloating, { showDecisionSupportWizard: showDecisionSupportWizard, decisionSupportInformation: decisionSupport })) : (React.createElement(DecisionAlertBar, { showDecisionSupportWizard: showDecisionSupportWizard, decisionSupportInformation: decisionSupport }))) : null));
}
